import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteContactsSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#contactsTable';
    searchSelector = '#contacts-search';
    clearSelector = '#contacts-search-clear';
    isAdmin: boolean;
    archiveContactId: number;
    token: string;
    

    url: string;

    constructor(handlerUrl: string, isAdmin: boolean){
        this.url = handlerUrl;
        this.isAdmin = isAdmin === true;
        this.token = document.querySelector('input[name="__RequestVerificationToken"]')?.getAttribute('value') ?? '';
        
        
        this.initialize();
        this.initializeArchiveModal();
        
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                // { data:'FirstName', title: 'First Name', className: '' },
                // { data:'LastName', title: 'Last Name', className: '' },
                { data:'ContactName', title: 'Name', className: '' },
                { data:'Email', title: 'Email', className: '' },
                { data: "StudyNameAndRole", title: "Study (Role)", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                { data:'PhoneNumber', title: 'Phone', className: '' },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: (data, type, row) => {
                        let html = `
                            <button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                        if (this.isAdmin) {
                            html += `<button class="archive-contact-btn ml-2" data-id="${row.Id}" data-name="${row.ContactName}" title="Archive"><i class="ctms-icon-archive"></i></button>`;
                        }
                        return html;
                    }
                }
            ],
        });

        InitializeFilterDropdown('#contacts-study', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $(this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });
        $(document).on(
            'click',
            `${this.tableSelector} .archive-contact-btn`,
            (e) => {
                const $btn = $(e.currentTarget);

                this.archiveContactId = parseInt(
                    String($btn.data('id')),
                    10
                );

                $('#archiveContactName').text($btn.data('name'));

                $('#archiveContactModal').modal('show');
            }
        );

    }

    initializeArchiveModal(): void {
        $('#archiveContactModal').modal({
            backdrop: 'static',
            show: false,
        });

        $('#confirmArchiveContactBtn').on('click', () => {
            $('#confirmArchiveContactBtn').prop('disabled', true);
            $('#archiveContactSpinner').show();

            $.ajax({
                url: '/secure/ctms/contacts/contacts?handler=ArchiveContact',
                headers: { "RequestVerificationToken": this.token },
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({ Id: this.archiveContactId }),
                success: (resp) => {
                    if (resp.success) {
                        const idToRemove = this.archiveContactId;

                        this.items = this.items.filter(
                            contact => contact.Id !== idToRemove
                        );

                        this.itemsTable
                            .rows((idx, data: any) => data.Id === idToRemove)
                            .remove()
                            .draw();

                        $('#archiveContactModal').modal('hide');
                        
                    } else {
                        alert(
                            'Error archiving contact: ' +
                            (resp.error ?? 'Unknown error.')
                        );
                    }
                },
                error: () => {
                    alert('Error archiving contact.');
                },
                complete: () => {
                    $('#confirmArchiveContactBtn').prop('disabled', false);
                    $('#archiveContactSpinner').hide();
                }
            });
        });
    }

    async loadData() {
        $('#contactsSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        const studyValues = Unique(this.items.map(c => c.StudyNames).flat(), true).sort();
        $('#contacts-study').empty();
        $('#contacts-study').append(studyValues.map(e => new Option(e, e, false, true)));
        $('#contacts-study').selectpicker("refresh");

        $('#contactsSectionLoading').addClass('d-none');
    }

    triggerFilter() {
        const study = $('#contacts-study').val() as [any];

        const filteredItems = this.items.filter((c) => {
            return study.some(s => c.StudyNames.includes(s));
        });


        this.itemsTable.clear();

        this.itemsTable.rows.add(filteredItems).draw();
    }
}